import { createSelector } from 'reselect';

import type { SCENARIO_STEP } from 'commonTypes/api/scenarios/BaseTypes';
import { MPL_PRODUCT_TYPES } from 'commonTypes/api/scenarios/ProductType';
import type { ContentOfType } from 'commonTypes/api/scenarios/scenario';

import { getScenarioContent } from 'entities/scenario';

export const selectIsCreditCard = createSelector(getScenarioContent, (content) => {
  const { offerInfo } = content as ContentOfType<SCENARIO_STEP.OFFER_DISBURSEMENT>;
  return offerInfo.productType === MPL_PRODUCT_TYPES.CREDIT_CARD;
});
